import { breakpointKeys, currentBreakpointIndex } from '../utils/windowResize';
import { onWindowResize } from './windowResize';
import { onScroll } from './scroll';

export const isBot = (!('onscroll' in window)) || (typeof navigator !== 'undefined' && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent));

let lastUsedScreenWidth;
let lazyArray = [];

let options = {
    className: 'lazy',
    loadedClass: 'lazy--loaded',
    loadClass: 'lazy--loading',
    decodeImg: true,
    oldIe11Fit: false,
    offset: 0
};

export function setupLazyLoading(customOptions = {}) {
    lastUsedScreenWidth = -1;
    options = { ...options, ...customOptions };
    lazyArray = document.body.getElementsByClassName(options.className);

    onWindowResize(lazyLoad);
    onScroll(lazyLoad, true);
}

function lazyLoad() {
    if (isBot || lastUsedScreenWidth < currentBreakpointIndex) {

        for (let i = 0; i < lazyArray.length; i++) {
            const lazyElem = lazyArray[i];

            if (isBot || isInViewport(lazyElem)) {
                lazyElem.classList.add(options.loadClass);
                if (lazyElem.classList.contains('lazy--bg')) {
                    loadBgImage(lazyElem);
                } else {
                    loadLazyImage(lazyElem);
                }
            }
        }

        cleanLazy();
    }
}

function cleanLazy() {
    lazyArray = Array.prototype.filter.call(lazyArray, l => !l.classList.contains(options.loadClass));
}

function isInViewport(el) {
    const rect = el.getBoundingClientRect();

    return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top - options.offset <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left - options.offset <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export function loadBgImage(bgContainer) {
    const src = getImageSrc(bgContainer);
    const handleLoadedBg = () => {
        bgContainer.style.backgroundImage = formattedSrc;
        bgContainer.classList.add(options.loadedClass);
        bgContainer.classList.remove(options.loadClass);
    };

    if (!src) {
        return;
    }

    const formattedSrc = `url(${src})`;

    if (bgContainer.style.backgroundImage === formattedSrc) {
        return;
    }

    if (options.decodeImg) {
        loadImage(src).then(handleLoadedBg);
    } else {
        handleLoadedBg();
    }
}

export function loadLazyImage(container) {
    const src = getImageSrc(container);

    if (!src) {
        return;
    }

    if (options.decodeImg) {
        const oldImage = container.querySelector('img');
        if (oldImage && container.classList.contains(options.loadedClass)) {
            if (oldImage.getAttribute('src') === src) {
                if (options.oldIe11Fit) {
                    window.objectFitPolyfill(oldImage);
                }
                return;
            } else {
                container.removeChild(oldImage);
            }
        }

        loadImage(src).then(newImageTag => {
            if (container.tagName === 'IMG') {
                container.src = src;
            } else {
                const altText = container.getAttribute('data-alt') || '';
                newImageTag.setAttribute('alt', altText);

                container.appendChild(newImageTag);
            }

            container.classList.add(options.loadedClass);
            container.classList.remove(options.loadClass);

            if (options.oldIe11Fit) {
                window.objectFitPolyfill(newImageTag);
            }
        });
    } else {
        container.src = src;
        container.classList.add(options.loadedClass);
        container.classList.remove(options.loadClass);
    }
}

function decodeImage(newImage) {
    return 'decode' in newImage ? newImage.decode().then(() => newImage) : Promise.resolve(newImage);
}

export function loadImage(path) {
    const newImage = new Image();

    return new Promise(resolve => {
        newImage.addEventListener('load', () => decodeImage(newImage).then(image => resolve(image)), false);
        newImage.src = path;
    });
}

function getImageSrc(container) {
    let src = '';
    let largestBreakpointFound = 0;

    if (container.getAttribute('data-src')) {
        src = container.getAttribute('data-src');
        container.removeAttribute('data-src');
    } else {
        breakpointKeys.forEach((breakpointName, index) => {
            if (currentBreakpointIndex >= index) {
                if (index === 0 || index > largestBreakpointFound) {
                    const srcAttribute = `data-src-${breakpointName}`;
                    src = container.getAttribute(srcAttribute) || src;
                    container.removeAttribute(srcAttribute);
                    largestBreakpointFound = index;
                }
            }
        });
    }

    return src;
}
